import React, { useState } from "react";
import ClientData from "../Data/ClientData.json";
const OurClients = () => {
  const [noOfElement, setnoOfElement] = useState(6);
  const LoadMore = () => {
    setnoOfElement(noOfElement + noOfElement);
  };
  const slice = ClientData.slice(0, noOfElement);
  return (
    <>
      <section className="client-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Trusted by 800+ ISP Company</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-10 offset-lg-1 col-12">
              <div className="client-inner">
                <div className="row g-0">
                  {slice.map((SingleClients) => (
                    <div
                      className="col-lg-4 col-md-4 col-12"
                      key={SingleClients.id}
                    >
                      <div className={SingleClients.singleclass}>
                        <img src={SingleClients.logo} alt="#" />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-btn">
                <button to="#" className="theme-btn" onClick={() => LoadMore()}>
                  Load More
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurClients;
